import React from 'react';
import { FiCheck, FiX, FiAlertCircle, FiInfo } from 'react-icons/fi';
import { useNotification } from '../contexts/NotificationContext';

const NotificationModal = () => {
  const { notification, hideNotification } = useNotification();

  if (!notification) return null;

  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return <FiCheck className="w-6 h-6 text-green-400" />;
      case 'error':
        return <FiX className="w-6 h-6 text-red-400" />;
      case 'warning':
        return <FiAlertCircle className="w-6 h-6 text-yellow-400" />;
      case 'info':
        return <FiInfo className="w-6 h-6 text-blue-400" />;
      default:
        return <FiCheck className="w-6 h-6 text-green-400" />;
    }
  };

  const getStyles = (type) => {
    switch (type) {
      case 'success':
        return 'bg-green-500/80 border-green-500/30';
      case 'error':
        return 'bg-red-500/80 border-red-500/30';
      case 'warning':
        return 'bg-yellow-500/80 border-yellow-500/30';
      case 'info':
        return 'bg-blue-500/80 border-blue-500/30';
      default:
        return 'bg-green-500/80 border-green-500/30';
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50 animate-slide-down" role="alert" aria-live="assertive">
      <div className={`flex items-center space-x-3 p-4 rounded-xl border shadow-lg ${getStyles(notification.type)} max-w-sm`}>
        <div className="flex-shrink-0" aria-hidden="true">
          {getIcon(notification.type)}
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-white">{notification.message}</p>
        </div>
        <button
          onClick={hideNotification}
          className="flex-shrink-0 text-gray-500 hover:text-gray-400 transition-colors"
          aria-label="Dismiss notification"
        >
          <FiX className="w-4 h-4" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};

export default NotificationModal;
